/* ========================================
   PINFLAG - CÓDIGO PERSONALIZADO
   ======================================== */

/* ========================================
   CARRITO - RECOMENDACIONES
   ======================================== */

// Añade variante de bolsa al carro
function addToCartRecommended(button) {
  const span = button.querySelector(".cart-recommendations-text-button");
  if (span) {
    span.textContent = "añadiendo...";
  }
  const cartItem = button.closest(".cart-recommendations-cart-item ");

  const variantInput = cartItem.getElementsByClassName(
    "cart-recommendations-form-hidden"
  );
  const variantId = variantInput ? variantInput[0].value : null;

  if (variantId) {
    axios
      .post("/cart/add.js", {
        id: variantId,
        quantity: 1,
      })
      .then((response) => {
        console.log("Producto agregado al carrito:", response);
        span.textContent = "AÑADIR AL CARRO";
        setTimeout(() => refreshCartDrawer(), 1000);
      })
      .catch((error) => {
        console.error("Error al agregar el producto al carrito:", error);
      });
  } else {
    console.error("No se encontró el variant ID.");
  }
}

//Actualiza visualmente el carro-----------------------------------------------------------------------------------
function refreshCartDrawer() {
  return fetch("/cart")
    .then((response) => response.text())
    .then((cart) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cart, "text/html");

      const cartItems = doc.querySelector("#cart-items-list");

      if (cartItems) {
        const cartItemList = document.querySelector("#cart-items-list");
        console.log('cartItemList', cartItemList)
        cartItemList.innerHTML = cartItems ? cartItems.innerHTML : "";

        const drawerFooter = doc.querySelector(".drawer__footer");
        const drawerFooterOld = document.querySelector(".drawer__footer");
        drawerFooterOld.innerHTML = drawerFooter ? drawerFooter.innerHTML : "";

        const cartCountBubble = doc.querySelector(".cart-count-bubble");
        const cartCountBubbleOld = document.querySelector(".cart-count-bubble");
        cartCountBubbleOld.innerHTML = cartCountBubble
          ? cartCountBubble.innerHTML
          : "";
      } else {
        const cartEmpty = doc.querySelector("cart-drawer");
        const cartEmptyOld = document.querySelector("cart-drawer");
        cartEmptyOld.innerHTML = cartEmpty ? cartEmpty.innerHTML : "";

        const cartCountBubble = doc.querySelector(".cart-count-bubble");
        const cartCountBubbleOld = document.querySelector(".cart-count-bubble");
        cartCountBubbleOld.innerHTML = cartCountBubble
          ? cartCountBubble.innerHTML
          : "";
      }
    })
    .catch((error) => console.error("Error updating cart drawer:", error));
}

document.querySelectorAll(".cart-recommendations-cart-item").forEach((card) => {
  const selectSizeButton = card.querySelector(".select-size-button");
  const addToCartButton = card.querySelector(
    ".cart-recommendations-button-add"
  );

  const closeButton = card.querySelector(".close-variants-buttons-recommended");
  const variantButtons = card.querySelector(
    ".cart-recommendations-bag-message"
  );

  selectSizeButton.addEventListener("click", () => {
    if (addToCartButton) {
      addToCartButton.setAttribute("style", "display: block !important;");
      selectSizeButton.setAttribute("style", "display: none !important;");
      variantButtons.setAttribute("style", "display: block !important;");
    }
  });

  closeButton.addEventListener("click", () => {
    if (variantButtons) {
      addToCartButton.setAttribute("style", "display: none !important;");
      selectSizeButton.setAttribute("style", "display: block !important;");
      variantButtons.setAttribute("style", "display: none !important;");
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  // Crea un observer para detectar cambios en el DOM
  const observer = new MutationObserver(() => {
    // Verifica si el elemento '.cart-recommendations-cart-item' ha aparecido
    const items = document.querySelectorAll(".cart-recommendations-cart-item");
    
    if (items.length > 0) {
      items.forEach((item) => {
        // Aquí puedes ejecutar la lógica para trabajar con el nuevo item
        const selectSizeButton = item.querySelector(".select-size-button");
        const addToCartButton = item.querySelector(
          ".cart-recommendations-button-add"
        );
        const closeButton = item.querySelector(
          ".close-variants-buttons-recommended"
        );
        const variantButtons = item.querySelector(
          ".cart-recommendations-bag-message"
        );
        
        if (
          selectSizeButton &&
          addToCartButton &&
          closeButton &&
          variantButtons
        ) {
          selectSizeButton.addEventListener("click", () => {
            if (addToCartButton) {
              addToCartButton.setAttribute(
                "style",
                "display: block !important;"
              );
              selectSizeButton.setAttribute(
                "style",
                "display: none !important;"
              );
              variantButtons.setAttribute(
                "style",
                "display: block !important;"
              );
            }
          });
          
          closeButton.addEventListener("click", () => {
            if (variantButtons) {
              addToCartButton.setAttribute(
                "style",
                "display: none !important;"
              );
              selectSizeButton.setAttribute(
                "style",
                "display: block !important;"
              );
              variantButtons.setAttribute("style", "display: none !important;");
            }
          });
        }
      });
    }
  });
  
  // Configura el observer para observar el cuerpo del documento por cambios
  const config = { childList: true, subtree: true };
  observer.observe(document.body, config);
});

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(
    ".card-wrapper .product-form__submit"
  );

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const drawerInner = document.querySelector(".drawer__inner");

      if (drawerInner) {
        const hasClasses =
          drawerInner.classList.contains("cart-drawer-pinflag-flex-column") &&
          drawerInner.classList.contains("cart-drawer-pinflag-width");

        if (!hasClasses) {
          drawerInner.classList.add(
            "cart-drawer-pinflag-flex-column",
            "cart-drawer-pinflag-width"
          );
          console.log("Clases agregadas al drawer__inner");
        }
      }
    });
  });
});
/* ========================================
   CARRITO - OBSERVER DE WIDTH
   ======================================== */
document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const cartDrawer = document.querySelector("cart-drawer.drawer");
    if (cartDrawer) {
      clearInterval(interval);
      initCartObserver(cartDrawer);
    }
  }, 300);
});

function initCartObserver(cartDrawer) {
  console.log("🍥 CartDrawer encontrado");

  function updateCart() {
    console.log("updateCart");
    const drawerInner = document.querySelector(".drawer__inner");
    if (!drawerInner) return;

    const width = cartDrawer.classList.contains("is-empty") ? "40rem" : "72rem";
    drawerInner.style.setProperty("width", width, "important");
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        updateCart();
      }
    }
  });

  observer.observe(cartDrawer, { attributes: true });
  updateCart();
}

/* ========================================
   LOCAL STORAGE - USER INFORMATION
   ======================================== */
function formatRut(rut) {
  return rut.replace(/\./g, ""); // Elimina los puntos
}

function checkUserInformation() {
  const storedData = localStorage.getItem("userInformation");

  const userData = JSON.parse(storedData);
  const fullName = userData.names.split(" ");
  const first_name = fullName[0];
  const last_name = fullName.slice(1).join(" ");
  const email = userData.email;
  const rut = formatRut(userData.rut);

  console.log(first_name, last_name, email, rut);

  exponea.update({
    first_name: first_name,
    last_name: last_name,
    rut: rut,
    email: email,
  });

  exponea.identify({
    email_id: email,
  });
}

/* ========================================
   VARIANTES - SELECTOR
   ======================================== */

function updateSelectedVariant(button, cart = false) {
  console.log("entre a actualizar a variante ", cart);
  if (!cart) {
    const productCard = button.closest(".product-card-wrapper");
    const selectedVariantId = button.dataset.variantId;
    const hiddenVariantInput = productCard.querySelector(
      ".selected-variant-id"
    );
    const submitButton = productCard.querySelector(".product-form__submit");
    hiddenVariantInput.value = selectedVariantId;

    const variantButtons = productCard.querySelectorAll(".variant-button");

    variantButtons.forEach((btn) => {
      btn.classList.toggle(
        "selected",
        btn.dataset.variantId === selectedVariantId
      );
    });

    if (submitButton) {
      submitButton.disabled = false;
      const span = submitButton.querySelector("span");
      if (span) {
        span.textContent = submitButton.dataset.labelAdd || "agregar al carro";
      }
    }
  } else {
    const cartItem = button.closest(".cart-recommendations-cart-item ");

    const selectedVariantId = button.dataset.variantId;

    const hiddenVariantInput = cartItem.querySelector(
      ".cart-recommendations-form-hidden"
    );

    hiddenVariantInput.value = selectedVariantId;

    const variantButtons = cartItem.querySelectorAll(".variant-button");

    variantButtons.forEach((btn) => {
      btn.classList.toggle(
        "selected",
        btn.dataset.variantId === selectedVariantId
      );
    });
  }
}

/* ========================================
   FILTRO DE TALLAS - DRAG SCROLL
   ======================================== */
(function() {
  function initSizeDragScroll() {
    const sizeFilters = document.querySelectorAll('.filtro_tallas ul');
    
    sizeFilters.forEach(container => {
      if (container.dataset.dragInit) return;
      
      let isDragging = false;
      let hasMoved = false;
      let startX;
      let scrollStart;

      container.addEventListener('mousedown', (e) => {
        isDragging = true;
        hasMoved = false;
        startX = e.pageX;
        scrollStart = container.scrollLeft;
        container.style.cursor = 'grabbing';
      });

      container.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const x = e.pageX;
        const distance = (startX - x) * 1.5;
        if (Math.abs(distance) > 3) hasMoved = true;
        container.scrollLeft = scrollStart + distance;
      });

      container.addEventListener('mouseup', () => {
        isDragging = false;
        container.style.cursor = 'grab';
      });

      container.addEventListener('mouseleave', () => {
        isDragging = false;
        container.style.cursor = 'grab';
      });

      container.addEventListener('click', (e) => {
        if (hasMoved && e.target.closest('label')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      container.dataset.dragInit = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeDragScroll);
  } else {
    initSizeDragScroll();
  }

  if (typeof FacetFiltersForm !== 'undefined') {
    const orig = FacetFiltersForm.renderProductGridContainer;
    if (orig) {
      FacetFiltersForm.renderProductGridContainer = function(html) {
        orig.call(this, html);
        setTimeout(initSizeDragScroll, 50);
      };
    }
  }

  const obs = new MutationObserver((muts) => {
    for (const mut of muts) {
      if (mut.addedNodes.length > 0) {
        const has = Array.from(mut.addedNodes).some(n =>
          n.nodeType === 1 && (n.classList?.contains('filtro_tallas') || n.querySelector?.('.filtro_tallas'))
        );
        if (has) {
          setTimeout(initSizeDragScroll, 50);
          break;
        }
      }
    }
  });

  obs.observe(document.body, { childList: true, subtree: true });
})();




/* ========================================
   FILTRO TALLA - AUTO AVAILABILITY
   ======================================== */
(function() {
  function addAvailabilityToForm(form) {
    if (!form.querySelector('input[name="filter.v.availability"]')) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'filter.v.availability';
      input.value = '1';
      form.appendChild(input);
    }
  }

  document.addEventListener('change', (e) => {
    if (e.target.matches('.filtro_tallas input[type="checkbox"]')) {
      const form = e.target.closest('form');
      if (form) addAvailabilityToForm(form);
    }
  });
})();
